<template>
  <div class="home">
    <Banner></Banner>
    <Featrue></Featrue>

    <section class="contact bg-primary" id="contact">
      <div class="container">
        <h2>We're here to help</h2>
        <p>
          All of our knowledge right at your fingertips. Ask questions, give
          suggestions, or give feedbacks. We want you to have a great
          experience.
        </p>
        <Contact />
      </div>
    </section>
  </div>
</template>

//
<script>
import Contact from "@/components/Contact/Contact";
import Banner from "@/components/Banner/Banner";
import Featrue from "@/components/Featrue/Featrue";
export default {
  name: "Home",
  components: { Contact, Banner, Featrue }
};
</script>

<style scoped>
#contact {
  background: #fff !important;
  color: #000;
  padding: 0 0 50px;
}
@media (max-width: 500px) {
  #contact h2 {
    font-size: 30px !important;
  }
}
</style>
